// Agency and consultancy solution pages that sell team plans self-serve:
// team pricing and Switch & Save above the fold of the CTA band, demo as a secondary link.
export const teamOfferPages = new Set([
  '/solutions/account-management-software-for-agencies',
  '/solutions/agency-crm',
  '/solutions/crm-for-small-agencies',
  '/solutions/agency-project-management-software',
  '/solutions/agency-software-flat-pricing',
  '/solutions/proposal-software-for-agencies',
  '/solutions/retainer-billing-software-for-agencies',
  '/solutions/agency-time-tracking-software',
  '/solutions/client-portal-and-billing-software',
  '/solutions/client-portal-for-agencies',
  '/solutions/consulting-firm-software',
  '/solutions/creative-agency-project-management-software',
  '/solutions/crm-for-ai-automation-agencies',
  '/solutions/crm-for-branding-agencies',
  '/solutions/crm-for-content-marketing-agencies',
  '/solutions/crm-for-cybersecurity-consultants',
  '/solutions/crm-for-email-marketing-agencies',
  '/solutions/crm-for-fractional-executives-cmo-cfo-coo',
  '/solutions/crm-for-growth-growth-operator-agencies',
  '/solutions/crm-for-hr-consultants',
  '/solutions/crm-for-influencer-marketing-agencies',
  '/solutions/crm-for-lead-generation-agencies',
  '/solutions/crm-for-management-consultants',
  '/solutions/crm-for-marketing-consultants',
  '/solutions/crm-for-no-code-low-code-agencies',
  '/solutions/crm-for-performance-marketing-agencies',
  '/solutions/crm-for-ppc-paid-ads-agencies',
  '/solutions/crm-for-social-media-marketing-agencies',
  '/solutions/crm-for-software-consultancies',
  '/solutions/crm-for-web-development-agencies',
  '/solutions/invoicing-software-for-consultants',
  '/solutions/marketing-agency-project-management-software',
  '/solutions/pr-agency-software',
  '/solutions/project-profitability-software-for-agencies',
  '/solutions/proposal-software-for-consultants',
  '/solutions/seo-agency-management-software',
  '/solutions/web-design-agency-software',
]);

export function isTeamOfferPage(slug: string): boolean {
  return teamOfferPages.has(slug.replace(/\/$/, ''));
}
